import { TagListItem } from "@/app/types/tags";

export const groupServicesByDepartment = (
  tags: TagListItem[]
): { groupName: string; items: TagListItem[] }[] => {
  const departments = tags.filter((t) => t.type === "department");
  const services = tags.filter((t) => t.type === "service");

  const deptMap = new Map<number, string>();
  departments.forEach((d) => deptMap.set(d.tag_id, d.name));

  const groups: Record<string, TagListItem[]> = {};

  services.forEach((svc) => {
    const parentId = svc.path.length > 1 ? svc.path[svc.path.length - 2] : null;
    const deptName = parentId ? deptMap.get(parentId) : "Other Services";

    const key = deptName || "Other Services";
    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(svc);
  });

  return Object.entries(groups).map(([groupName, items]) => ({
    groupName,
    items,
  }));
};

export const flattenServiceTags = (tags: TagListItem[]): TagListItem[] => {
  return tags.filter((tag) => tag.type === "service");
};
